import { MakerFinance } from './../../../../types/estimate/common/PaymentWay';
import { OtherBank } from '../../../../types/estimate/common/OtherBank';
import { Trim } from '../../../../types/common/car/CarInfo';
import { getOtherBankItem } from './initObj';

export interface RefineParam {
  trim: Trim;
  registrationTotalPrice: number;
  totalPriceWithoutConsignmentPrice: number;
  consignmentPrice: number;
  totalPriceWithConsignmentPrice: number;
  taxInvoice: number;
  deposit: number;
  insuarancePremium: number;
  period: number;
  advanceReceivedRate: number;
  productList: MakerFinance[];
}

/**
 *  타금융사 할부 목록을 테이블에 뿌려지는 아이템 형태로 변환시켜주는 함수
 * @param {Trim} trim 트림정보
 * @param {number} registrationTotalPrice 등록합계
 * @param {number} totalPriceWithoutConsignmentPrice 합계-탁송료
 * @param {number} consignmentPrice 탁송료
 * @param {number} totalPriceWithConsignmentPrice 합계+탁송료
 * @param {number} taxInvoice 세금계산서(인도금대납반영전)
 * @param {number} deposit 계약금
 * @param {number} insuarancePremium 의무보험료
 * @param {number} period 기간
 * @param {number} advanceReceivedRate 선수율
 * @param {MakerFinance[]} productList 타금융사 할부 목록
 *  */
export const refineOtherBankList = ({
  trim,
  registrationTotalPrice,
  totalPriceWithoutConsignmentPrice,
  consignmentPrice,
  totalPriceWithConsignmentPrice,
  taxInvoice,
  deposit,
  insuarancePremium,
  period,
  advanceReceivedRate,
  productList,
}: RefineParam): OtherBank[] => {
  if (!!!productList.length) {
    return [];
  }

  return productList.map(
    (item: MakerFinance) =>
      item &&
      getOtherBankItem(item, {
        trim,
        registrationTotalPrice,
        totalPriceWithoutConsignmentPrice,
        consignmentPrice,
        totalPriceWithConsignmentPrice,
        taxInvoice,
        deposit,
        insuarancePremium,
        period,
        advanceReceivedRate,
        productList,
      })
  );
};
